import { Component, EventEmitter, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppState } from '../../../../../Store/app.state/app.state';
import { Observable } from 'rxjs';
import { SCENE_MODE } from '../../../../../Store/app.state/app.model';
import { IViewpoint } from '../../../../../Store/viewpoints.state/viewpoints.model';
import { CopyLinkService } from '../../../../../services/copy-link.service';
import { DialogService, DialogType } from 'src/app/services/dialogs.service';
import { ApiTools } from 'src/app/services/api.services/api.tools';
import { DataPrivacyApiSvc } from 'src/app/services/api.services/data-privacy.api.svc';
import { SiemensAnalyticsService } from 'src/app/services/siemens-analytics.service';
import { environment } from 'src/environments/environment';
import { OperationStatusBoardDialogComponent } from 'src/app/common/Forms/Dialogs/operation-status-board-dialog/operation-status-board-dialog.component';
import { ILayer } from 'src/app/Store/layers.state/layers.model';
import { PermissionsManager, ACTION_TYPE, Actions } from 'src/app/services/permissions-manager';
import { LayersState } from 'src/app/Store/layers.state/layers.state';
import { ISite } from 'src/app/Store/sites.state/sites.model';
import { PointCloudSvc } from 'src/app/services/api.services/point-cloud.service';
import { PerfectScrollbarModule } from 'perfect-scrollbar-angular';
import { MatIcon } from '@angular/material/icon';

import { ExpansionBoxComponent } from '../../../../../common/UI-Components/expansion-box/expansion-box.component';

export const SIEGLE_PROXY: string = 'intosite-proxy';
export const MAIN_HTML: string = 'Main.html';

export const CLIENT_REDIRECT_NOTIFIER: string = 'redirect';

@Component({
    selector: 'ins-settings-panel',
    templateUrl: './settings-panel.component.html',
    styleUrls: ['./settings-panel.component.css', './../submenus-shared-design.scss',
        './../../../../../common/UI-Components/shared-UI-components.scss'],
    imports: [PerfectScrollbarModule, MatIcon, ExpansionBoxComponent]
})
export class SettingsPanelComponent implements OnInit {
  selectedMode$: Observable<SCENE_MODE>;
  currentViewpoint$: Observable<IViewpoint>;
  activeSite$: Observable<ISite>;
  siteLayers$: Observable<ILayer[]>;

  @Output()
  public closePanel: EventEmitter<void> = new EventEmitter();
  public isAdmin: boolean = false;
  public isSiteAdmin: boolean = false;
  public isPerm2DEdit: boolean = false;
  public useSan = environment.useSan;

  constructor(private readonly copyLinkService: CopyLinkService, private readonly dialogService: DialogService, 
    private readonly dataPrivacyApiSvc: DataPrivacyApiSvc, private readonly siemensAnalyticsService: SiemensAnalyticsService,
    private readonly pointCloudSvc: PointCloudSvc, private store: Store) {
    this.currentViewpoint$ = this.store.select(AppState.getCurrentViewpoint);
    this.selectedMode$ = this.store.select(AppState.getSelectedMode);
    this.activeSite$ = this.store.select(AppState.getActiveSite);
    this.siteLayers$ = this.store.select(LayersState.getSiteLayers);
    if (ApiTools.userRoles) {
      ApiTools.userRoles.includes('ADMIN') && (this.isAdmin = true);
      ApiTools.userRoles.includes('SITE_ADMIN') && (this.isSiteAdmin = true);
    }
  }

  ngOnInit(): void {
    this.activeSite$.subscribe((site: ISite) => {
      if (site) {
        this.isPerm2DEdit = false;
        this.check2DEditPermission();
      }
    });
  }

  check2DEditPermission(): void {
    let sub;
    sub = this.siteLayers$.subscribe((layers: ILayer[]) => {
      layers.forEach((layer: ILayer) => {
        PermissionsManager.isPermitted$(Actions.LAYER_2D_MODEL, ACTION_TYPE.UPDATE, layer.id).subscribe((isPerm: boolean) => {
          this.isPerm2DEdit = this.isPerm2DEdit || isPerm;
        });
        PermissionsManager.isPermitted$(Actions.LAYER_2D_MODEL, ACTION_TYPE.CREATE, layer.id).subscribe((isPerm: boolean) => {
          this.isPerm2DEdit = this.isPerm2DEdit || isPerm;
        });
      });
      if (sub) {
        sub.unsubscribe();
        sub = null;
      }
    });
  }

  copyLink(): void {
    this.copyLinkService.copyViewpointLinkToClipboard();
    // Log Siemens Analytics event
    this.siemensAnalyticsService.logEvent('INS_CopyLink');
  }

  openWebPointCloudConfDialog(): void {
    this.pointCloudSvc.openWebPointCloudConfDialog();
  }

  openDataPrivacyDialog(context: string): void {
     this.dataPrivacyApiSvc.openDataPrivacyDialog(context);
  }

  removeUrlParam(url: string, param: string): string {
    let result: string = url;
    const startIndex: number = result.indexOf(param);
    if (startIndex !== -1) {
      const endIndex = result.indexOf('?', startIndex);
      if (endIndex === -1) {
        result = result.substr(0, result.indexOf(param) - 1);
      } else {
        result = result.replace(result.substr(startIndex - 1, endIndex) , '');
      }
    }
    return result;
  }

  openOperationStatusBoard(): void {
    this.dialogService.createDialog(OperationStatusBoardDialogComponent, DialogType.Modal, null, null, 1000);
  }
}
